export default __webpack_public_path__ + "static/media/152.0c95b99a.png";